export const environment = {
  redirectUrl: 'https://brandstandards.dcsg.com/home',
  postLogoutRedirectUrl: 'https://brandstandards.dcsg.com/login',
  environment: 'prod',
  clientId: 'b4de5b64-18cb-4118-af8b-f7b141416793', //app id in azure
  graphMeEndpoint:'https://graph.microsoft.com/v1.0/me?$select=givenName,surname,employeeId,id,userPrincipalName',
  tenantId: 'e04b15c8-7a1e-4390-9b5b-28c7c205a233',
  backendAppIdString: '0c365911-dd14-49f9-ac02-5de067924514/v1.0',
  rfm: '/prod/brandstandardsapi/v1/rfm',
  review: '/prod/brandstandardsapi/v1/Review',
  reviewImage: '/prod/brandstandardsapi/v1/ReviewImage',
  store: '/prod/brandstandardsapi/v1/Store',
  admin: '/prod/brandstandardsapi/v1/Admin',
  remodel: '/prod/brandstandardsapi/v1/remodelstatus',
  reportTemplate: "/prod/brandstandardsapi/v1/reportTemplate",
  standardTemplate: "/prod/brandstandardsapi/v1/standardTemplate",
  widget: '/prod/brandstandardsapi/v1/widget',
  dashboard: '/prod/brandstandardsapi/v1/dashboard',
  imgBaseline: '/dcsg-ngx-talisman',
  agGridLicenseKey: "Using_this_{AG_Grid}_Enterprise_key_{AG-065264}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Dcsg_Ventures_LLC}_is_granted_a_{Multiple_Applications}_Developer_License_for_{5}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{7_December_2025}____[v3]_[01]_MTc2NTA2NTYwMDAwMA==430347d429e9c847e30132034fe7e91c"
};
